<template>
  <div v-if="show">
    <PBannerBase height="auto" :inative="false" :isDefault="false" warning>
      <template #title>Atenção</template>
      O credenciamento da rede pode levar um pouco mais de tempo para ser
      efetivado, mesmo após a confirmação. Caso a consulta não retorne dados em
      um primeiro momento logo após o credenciamento, sugerimos que tente
      novamente mais tarde.
    </PBannerBase>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";

defineProps<{
  show?: boolean;
}>();
</script>
